export const SYNC_GROUPS_SCENES = '@@groupsScenes/syncGroupsScenes'

export const RESET_GROUPS_SCENES = '@@groupsScenes/reset'

export const UPDATE_GROUPS_SCENES = '@@groupsScenes/updateGroupsScenes'
